import { render } from "./OrderInfo.vue?vue&type=template&id=e2d5f1a2&ts=true"
import script from "./OrderInfo.vue?vue&type=script&lang=ts"
export * from "./OrderInfo.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__